export const formatLogMessage = (message) => {
    if (!message) return '';    
    return message.replace(/Kargoİst|kargoist|kargo-ist/gi, 'CargoX');
};